import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Reads ?token= from URL, exchanges it for a full session, and logs the user in.
 * Returns { loading } so the consuming component can show a spinner.
 */
const useTokenFromUrl = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const hasToken = !!searchParams.get("token");
  const [loading, setLoading] = useState(hasToken && !user);
  const attemptedRef = useRef(false);

  useEffect(() => {
    const webToken = searchParams.get("token");

    if (!webToken || user || attemptedRef.current) return;

    attemptedRef.current = true;
    setLoading(true);

    axios
      .post(`${BASE_URL}/auth/exchange-web-token`, { webToken })
      .then((res) => {
        const session = res.data;
        login(session, session.token);

        // Mark as mobile flow
        sessionStorage.setItem("source", "mobile");

        // Strip token from URL
        const url = new URL(window.location.href);
        url.searchParams.delete("token");
        navigate(url.pathname + url.search, { replace: true });
      })
      .catch((err) => {
        console.error("[useTokenFromUrl] Exchange failed:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchParams, user, login, navigate]);

  return { loading };
};

export default useTokenFromUrl;
